/* @ngInject */
export default function DetailsMediaPageController() {
  const ctrl = this

  ctrl.$onInit = () => {}
}
